<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-24
    	描述：后台母版
    -->
  <div :class="hasChild != null ? 'main' : 'main right-big'">
    <!--left menu-->
    <LeftMenu @selectMenu="selectMenuFunc" @selectMenuPath="selectMenuPath"></LeftMenu>

    <!--right content-->
    <RightContent v-if="showf"></RightContent>
    <RightContentb v-if="!showf"></RightContentb>
  </div>
</template>

<script>
import LeftMenu from '@/views/layout/LeftMenu.vue';
import RightContent from '@/views/layout/RightContent.vue';
import RightContentb from '@/views/layout/RightContentb.vue';
import store from '@/store/';
import {delCookie, setCookie} from '@/utils/base.js';
export default {
  components: {
    /*左菜单组件*/
    LeftMenu,
    /*右边内容容器*/
    RightContent,
    RightContentb
  },
  data() {
    return {
      /*是否有子菜单*/
      hasChild: null,
      /*系统基本数据*/
      baseInfo: {
        shop_name: '',
        user: {},
        version: '',
        app_id:'',
        w7:{},
        qr_code:"",//客服二维码
        qr_icon:"",//kefu图标
        token:"",
        logo:"",
      
      },
      showf:true,
    };
  },
  provide: function() {
    return {
      baseInfo: this.baseInfo
    };
  },
  created() {
    console.log('this.$route.query.from',this.$route.query)
    if(this.$route.query.from&&this.$route.query.from=='admin'){
      delCookie('baseInfo');
    }

    this.getBaseInof();
  },
  methods: {
    /*左边子组件传来的参数*/
    selectMenuFunc(param) {
      this.hasChild = param;
    },
    selectMenuPath(path){
      console.log('path',path)
        if(path == '/home' || path == '/statistics/new/notes'  || path == '/plus/plus/index1'){
          this.showf = false;
        }else{
          this.showf = true;
        }
        this.$forceUpdate()
    },
    async getBaseInof() {
      let res = await store.dispatch('common/getBaseInfo');
      this.baseInfo.shop_name = res.shop_name;
      this.baseInfo.version = res.version;
      this.baseInfo.user = res.user;
      this.baseInfo.app_id = res.app_id,
      this.baseInfo.w7 = res.w7
      this.baseInfo.qr_code = res.qr_code
      this.baseInfo.qr_icon = res.qr_icon;
      this.baseInfo.logo = res.logo;
      console.log("this.baseInfo:",this.baseInfo)
      if(res.token){
        setCookie("token", res.token);
      }
   
      
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/layout/main.vue